// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"4da5cbc6","371":"ee82f721"}[chunkId] + ".js";
};